var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItaliannis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.378,
    height: 27.873,
    viewBox: "0 0 84.378 27.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ITALIANNIS",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27606",
    "data-name": "Trazado 27606",
    d: "M140.214,48.88c0-.125-.1-.161-.187-.161-.062,0-.172.021-.172.141a.1.1,0,0,0,.089.1l.219.052a.208.208,0,0,1,.172.219c0,.193-.167.245-.3.245a.29.29,0,0,1-.229-.078.248.248,0,0,1-.078-.2h.094a.185.185,0,0,0,.208.187c.073,0,.2-.021.2-.135,0-.083-.036-.109-.161-.141l-.156-.036a.189.189,0,0,1-.161-.193.24.24,0,0,1,.26-.25c.266,0,.292.167.3.26h-.094Z",
    transform: "translate(-66.96 -23.304)",
    fill: "#1e1e22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27607",
    "data-name": "Trazado 27607",
    d: "M141.755,49.462V48.78h0l-.214.677h-.1l-.214-.677h0v.677h-.1V48.65h.146l.214.682h0l.219-.682h.146v.807h-.1Z",
    transform: "translate(-67.631 -23.314)",
    fill: "#1e1e22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27608",
    "data-name": "Trazado 27608",
    d: "M42.174,27.873c23.3.026,42.2-6.187,42.2-13.884S65.5.026,42.2,0,.01,6.187,0,13.884,18.873,27.841,42.174,27.873",
    transform: "translate(0 0)",
    fill: "#004d41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27609",
    "data-name": "Trazado 27609",
    d: "M14.6,5.831C6.807,8.221,2.51,11.455,2.51,14.929s4.281,6.718,12.072,9.129c7.7,2.385,17.926,3.7,28.8,3.718a110.212,110.212,0,0,0,24.685-2.541c7.046-1.651,12.077-3.911,14.546-6.536a5.377,5.377,0,0,0,1.672-3.672,5.4,5.4,0,0,0-1.661-3.677c-2.463-2.63-7.489-4.906-14.53-6.572a110.263,110.263,0,0,0-24.68-2.6C32.539,2.164,22.31,3.461,14.608,5.825m28.784,21.43c-10.832-.01-21.014-1.328-28.669-3.7-7.463-2.3-11.733-5.447-11.728-8.624s4.281-6.312,11.739-8.6C22.389,3.977,32.575,2.69,43.408,2.7c17.936.021,33.919,3.729,38.867,9.02a4.881,4.881,0,0,1,1.521,3.312,4.887,4.887,0,0,1-1.526,3.307c-4.958,5.276-20.951,8.947-38.887,8.926",
    transform: "translate(-1.203 -1.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27610",
    "data-name": "Trazado 27610",
    d: "M26.112,23.867c-.651,0-1.031-.036-1.2-.219a.772.772,0,0,1-.141-.557l.01-7.562c0-.667.187-.776,1.318-.771h.062V14.18H21.95v.573h.063c1.109,0,1.307.115,1.307.776l-.01,7.557c0,.656-.2.776-1.307.771H21.94v.578h4.229v-.573h-.062Z",
    transform: "translate(-10.514 -6.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27611",
    "data-name": "Trazado 27611",
    d: "M35.829,24.964l-.031.073a.91.91,0,0,1-.911.682c-.755,0-.818-.969-.818-1.271V20.115h1.515v-.677H34.068V17.86h-.7l-.01.052c-.24,1.068-.354,1.38-1.318,1.526l-.057.01v.667h.786c0,.135-.005,4.666-.005,4.666a1.651,1.651,0,0,0,1.656,1.672,1.706,1.706,0,0,0,1.807-1.13l.031-.057-.437-.3Z",
    transform: "translate(-15.325 -8.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27612",
    "data-name": "Trazado 27612",
    d: "M47.911,26.282l-.026.073c-.193.521-.521.4-.526.4-.276-.109-.333-.266-.333-.885v-3.3a1.655,1.655,0,0,0-.437-1.224,3.268,3.268,0,0,0-2.291-.88c-1.125,0-2.286.594-2.286,1.588a.6.6,0,0,0,.224.495.609.609,0,0,0,.594.057.621.621,0,0,0,.37-.354.913.913,0,0,0,.068-.37,1.99,1.99,0,0,0-.083-.521,1.622,1.622,0,0,1,1.016-.271c.974,0,1.489.469,1.489,1.354v.76c-.068.031-.7.3-.7.3C43.656,24.048,42,24.736,42,26.121h0a1.342,1.342,0,0,0,.375.932,1.844,1.844,0,0,0,1.328.557,2.236,2.236,0,0,0,2.12-1.083,1.072,1.072,0,0,0,1.2,1.088A1.138,1.138,0,0,0,48.328,26.6l.01-.047-.427-.276Zm-3.942.661a.749.749,0,0,1-.729-.766h0c0-1.078,1.651-2.015,2.489-2.318v.682c0,1.552-.625,2.4-1.755,2.4h0Z",
    transform: "translate(-20.127 -9.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27613",
    "data-name": "Trazado 27613",
    d: "M79.186,26.317l-.026.078c-.193.521-.521.4-.521.4-.276-.109-.339-.266-.339-.885V22.6a1.662,1.662,0,0,0-.437-1.224,3.268,3.268,0,0,0-2.291-.88c-1.125,0-2.286.594-2.286,1.588a.6.6,0,0,0,.224.495.609.609,0,0,0,.594.057.615.615,0,0,0,.37-.359.913.913,0,0,0,.068-.37,1.758,1.758,0,0,0-.089-.521,1.622,1.622,0,0,1,1.016-.271c.974,0,1.489.469,1.489,1.354v.76l-.7.3c-1.333.552-2.989,1.239-2.989,2.625h0a1.622,1.622,0,0,0,1.708,1.495,2.236,2.236,0,0,0,2.12-1.083,1.072,1.072,0,0,0,1.2,1.088A1.138,1.138,0,0,0,79.6,26.64v-.047l-.417-.276Zm-3.942.661a.73.73,0,0,1-.526-.24.749.749,0,0,1-.2-.526h0c0-1.078,1.651-2.015,2.489-2.318v.682c0,1.552-.625,2.4-1.76,2.4",
    transform: "translate(-35.112 -9.824)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27614",
    "data-name": "Trazado 27614",
    d: "M58.96,24.682a.97.97,0,0,1-.7-.177.941.941,0,0,1-.146-.651l.01-7.984-.073.016-2.344.422v.573l.167.01c.833.047.9.052.9.687v6.177a1.236,1.236,0,0,1-.151.771c-.125.13-.375.156-.734.156H55.83v.6h3.2v-.6H58.97Z",
    transform: "translate(-26.697 -7.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27615",
    "data-name": "Trazado 27615",
    d: "M66.07,17.788a.8.8,0,0,0,.781-.807.781.781,0,0,0-1.562,0,.8.8,0,0,0,.781.807m.838,6.328V18.658l-2.349.453v.464c.984.016,1.135-.073,1.135.823v3.588c-.005.833-.13.932-1.052.932v.464h3.2v-.458c-.833-.052-.932-.156-.932-.807",
    transform: "translate(-30.938 -7.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27616",
    "data-name": "Trazado 27616",
    d: "M124.039,24.858c-.818-.052-.87-.141-.87-.74V18.583l-.068.016-2.291.464v.588h.307c.766,0,.828,0,.828.755v3.588c0,.359-.026.588-.141.708-.125.135-.385.161-.849.156h-.068v.6H124.1v-.594h-.062Zm-1.656-7a.832.832,0,0,0,.609-.266.872.872,0,0,0,.24-.609.847.847,0,0,0-1.463-.588.832.832,0,0,0-.229.583.9.9,0,0,0,.24.609.824.824,0,0,0,.609.266",
    transform: "translate(-57.893 -7.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27617",
    "data-name": "Trazado 27617",
    d: "M110.506,26.725V23.116a1.939,1.939,0,0,0-2.1-2.156,2.117,2.117,0,0,0-2.208,1.318h-.026V20.96l-1.953.432v.448c.932.026.8.01.8.776v3.807c-.005.719-.307.922-1.057.922v.333h3.073v-.333c-.76,0-.828-.255-.828-.9v-2.1c0-1.078.568-2.786,1.937-2.786.568,0,1.177.406,1.172,1.542v3.364c0,.667-.068.88-.729.88v.339h2.859v-.339c-.469,0-.937-.187-.937-.625",
    transform: "translate(-49.819 -10.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27618",
    "data-name": "Trazado 27618",
    d: "M89.44,20.786l-2.005.448v.573h.109c.4.01.594.016.661.089.047.052.042.172.036.37v.25l-.01,3.807c0,.646-.24.849-.984.849H87.18v.474h3.2v-.474H90.32a.856.856,0,0,1-.63-.161,1.008,1.008,0,0,1-.135-.667v-2.1c0-1.13.583-2.719,1.875-2.719a1.011,1.011,0,0,1,.745.318A1.66,1.66,0,0,1,92.539,23v3.364c0,.656-.068.812-.667.812H91.8v.474h2.989v-.469h-.062c-.437,0-.875-.172-.875-.557V23.015a2,2,0,0,0-2.172-2.229,2.158,2.158,0,0,0-2.166,1.161V20.77Z",
    transform: "translate(-41.778 -9.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27619",
    "data-name": "Trazado 27619",
    d: "M135.821,25.581c-.031-1.344-1-1.776-1.854-2.156-.708-.312-1.312-.578-1.312-1.276h0a.87.87,0,0,1,.9-.849c.948,0,1.229.516,1.463,1.6l.01.052h.4v-2.3h-.484l-.016.047c-.068.208-.182.229-.417.229a.8.8,0,0,1-.286-.057,1.664,1.664,0,0,0-.615-.094,2.134,2.134,0,0,0-1.484.672,1.739,1.739,0,0,0-.49,1.2c0,1.453,1.005,1.917,1.9,2.328.672.312,1.255.578,1.25,1.213a1.109,1.109,0,0,1-1.135,1.094c-.891,0-1.443-.568-1.7-1.729l-.01-.052h-.4v2.3h.484l.016-.047c.068-.208.182-.229.411-.229a1.342,1.342,0,0,1,.422.1,2.391,2.391,0,0,0,.828.172,2.155,2.155,0,0,0,1.568-.625,2.223,2.223,0,0,0,.547-1.526h0V25.6h-.01Z",
    transform: "translate(-63.035 -9.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27620",
    "data-name": "Trazado 27620",
    d: "M130.17,15.915h-.005c-.005,0-.016-.01-.021-.016a.611.611,0,0,0-.333-.1.686.686,0,0,0,0,1.37.551.551,0,0,0,.161-.026v.094a2.938,2.938,0,0,1-.781,1.229l.2.161a3.1,3.1,0,0,0,1.115-1.984.859.859,0,0,0-.323-.719",
    transform: "translate(-61.9 -7.572)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27621",
    "data-name": "Trazado 27621",
    d: "M28.351,40.332v-.458h.578c.682,0,.833-.172.833-.677,0-.469-.229-.656-.833-.656H27.7v1.792Zm0-.875v-.505H28.8c.255,0,.3.057.3.245,0,.234-.036.255-.3.26Z",
    transform: "translate(-13.274 -18.469)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27622",
    "data-name": "Trazado 27622",
    d: "M35.742,40.014l.125.307h.661l-.74-1.792H34.8l-.729,1.792h.677l.12-.307Zm-.13-.349h-.6l.3-.776h.005Z",
    transform: "translate(-16.327 -18.464)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27623",
    "data-name": "Trazado 27623",
    d: "M42.643,39.233c.719.036.9.1.9.516,0,.3.016.588-1.057.588-.62,0-1.031-.01-1.031-.594h.62c0,.187.094.2.411.2s.406-.016.406-.161-.036-.151-.339-.167H42.4c-.6-.042-.953-.036-.953-.552s.391-.547,1.031-.547c.536,0,.989.01.989.505V39.1h-.62c0-.182-.1-.182-.365-.182-.349,0-.38.052-.38.156,0,.146.094.151.266.161l.271.016Z",
    transform: "translate(-19.863 -18.459)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27624",
    "data-name": "Trazado 27624",
    d: "M49.461,40.332H48.81v-1.38h-.62V38.54h1.927v.411h-.656Z",
    transform: "translate(-23.093 -18.469)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27625",
    "data-name": "Trazado 27625",
    d: "M55.8,40.014l.125.307h.661l-.74-1.792h-.99l-.729,1.792h.677l.12-.307Zm-.13-.349h-.6l.3-.776h.005Z",
    transform: "translate(-25.94 -18.464)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27626",
    "data-name": "Trazado 27626",
    d: "M65.656,40.332v-.458h.578c.682,0,.833-.172.833-.677,0-.469-.229-.656-.833-.656H65.01v1.792Zm0-.875v-.505H66.1c.255,0,.292.057.292.245,0,.234-.036.255-.292.26Z",
    transform: "translate(-31.153 -18.469)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1973",
    "data-name": "Rect\\xE1ngulo 1973",
    width: 0.646,
    height: 1.792,
    transform: "translate(37.476 20.071)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27627",
    "data-name": "Trazado 27627",
    d: "M78.219,38.936l-1.161.963v.016h1.161v.417H76.23v-.406l1.151-.958v-.016H76.308V38.54h1.911Z",
    transform: "translate(-36.53 -18.469)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27628",
    "data-name": "Trazado 27628",
    d: "M84.829,38.936l-1.167.963v.016h1.167v.417H82.84v-.406l1.146-.958v-.016H82.913V38.54h1.917Z",
    transform: "translate(-39.698 -18.469)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27629",
    "data-name": "Trazado 27629",
    d: "M90.9,40.014l.125.307h.661l-.74-1.792h-.99l-.729,1.792h.677l.12-.307Zm-.13-.349h-.6l.3-.776h.005Z",
    transform: "translate(-42.76 -18.464)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27630",
    "data-name": "Trazado 27630",
    d: "M101.071,40.312l.286-.255-.271-.182a.314.314,0,0,0,.068-.177v-.354h-.521v.234l-.6-.391c-.078-.057-.13-.094-.13-.177,0-.13.047-.156.214-.156.13,0,.2.005.24.036s.047.089.042.187h.557V38.99c.005-.432-.292-.49-.844-.49s-.812.068-.812.479a.294.294,0,0,0,.182.3c-.37.01-.432.245-.432.474,0,.521.432.568,1.057.568a1.054,1.054,0,0,0,.724-.161l.224.146Zm-.615-.4a1.089,1.089,0,0,1-.333.036c-.3,0-.464,0-.464-.24,0-.089-.005-.2.151-.214l.646.411Z",
    transform: "translate(-47.466 -18.45)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27631",
    "data-name": "Trazado 27631",
    d: "M109.7,38.54h.672l-.713,1.792h-1.016l-.687-1.792h.661l.526,1.38h.021Z",
    transform: "translate(-51.736 -18.469)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1974",
    "data-name": "Rect\\xE1ngulo 1974",
    width: 0.646,
    height: 1.792,
    transform: "translate(60.089 20.071)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27632",
    "data-name": "Trazado 27632",
    d: "M120.541,40.332h-.651V38.54h1.1l.7,1.375h.026l-.036-1.375h.651v1.792h-1.109l-.693-1.38H120.5Z",
    transform: "translate(-57.453 -18.469)",
    fill: "#ef3e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27633",
    "data-name": "Trazado 27633",
    d: "M128.775,40.333c.656,0,1.125-.1,1.125-.656v-.51c0-.552-.469-.656-1.125-.656s-1.125.1-1.125.656v.51c0,.552.469.656,1.125.656m0-.417c-.339,0-.448-.026-.458-.3v-.406c.01-.266.12-.292.458-.292s.458.026.458.292v.406c0,.271-.12.3-.458.3",
    transform: "translate(-61.171 -18.454)",
    fill: "#ef3e33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaliannis);
export default __webpack_public_path__ + "static/media/italiannis.90d779bfa83082751bfe3606187ac595.svg";
export { ForwardRef as ReactComponent };